import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// Import all 50 project components
import Project_1 from "../sub_projects/Project_1/Project_one";
import Project_2 from "../sub_projects/Project_2/Project_two";
import Project_3 from "../sub_projects/Project_3/Project_three";
import Project_4 from "../sub_projects/Project_4/Project_four";
import Project_5 from "../sub_projects/Project_5/Project_five";

import Project_6 from "../sub_projects/Project_6/Project_six";
import Project_7 from "../sub_projects/Project_7/Project_seven";
import Project_8 from "../sub_projects/Project_8/Project_eight";
import Project_9 from "../sub_projects/Project_9/Project_nine";
import Project_10 from "../sub_projects/Project_10/Project_ten";

import Project_11 from "../sub_projects/Project_11/Project_eleven";
import Project_12 from "../sub_projects/Project_12/Project_twelve";
import Project_13 from "../sub_projects/Project_13/Project_thirteen";
import Project_14 from "../sub_projects/Project_14/Project_fourteen";
import Project_15 from "../sub_projects/Project_15/Project_fiveteen";

import Project_16 from "../sub_projects/Project_16/Project_sixteen";
import Project_17 from "../sub_projects/Project_17/Project_seventeen";
import Project_18 from "../sub_projects/Project_18/Project_eighteen";
import Project_19 from "../sub_projects/Project_19/Project_nineteen";
import Project_20 from "../sub_projects/Project_20/Project_twenty";

import Project_21 from "../sub_projects/Project_21/Project_twentyone";
import Project_22 from "../sub_projects/Project_22/Project_twentytwo";
import Project_23 from "../sub_projects/Project_23/Project_twentythree";
import Project_24 from "../sub_projects/Project_24/Project_twentyfour";
import Project_25 from "../sub_projects/Project_25/Project_twentyfive";

import Project_26 from "../sub_projects/Project_26/Project_twentysix";
import Project_27 from "../sub_projects/Project_27/Project_twentyseven";
import Project_28 from "../sub_projects/Project_28/Project_twentyeight";
import Project_29 from "../sub_projects/Project_29/Project_twentynine";
import Project_30 from "../sub_projects/Project_30/Project_thirty";

import Project_31 from "../sub_projects/Project_31/Project_thirtyone";
import Project_32 from "../sub_projects/Project_32/Project_thirtytwo";
import Project_33 from "../sub_projects/Project_33/Project_thirtythree";
import Project_34 from "../sub_projects/Project_34/Project_thirtyfour";
import Project_35 from "../sub_projects/Project_35/Project_thirtyfive";

import Project_36 from "../sub_projects/Project_36/Project_thirtysix";
import Project_37 from "../sub_projects/Project_37/Project_thirtyseven";
import Project_38 from "../sub_projects/Project_38/Project_thirtyeight";
import Project_39 from "../sub_projects/Project_39/Project_thirtynine";
import Project_40 from "../sub_projects/Project_40/Project_forty";

import Project_41 from "../sub_projects/Project_41/Project_fortyone";
import Project_42 from "../sub_projects/Project_42/Project_fortytwo";
import Project_43 from "../sub_projects/Project_43/Project_fortythree";
import Project_44 from "../sub_projects/Project_44/Project_fortyfour";
import Project_45 from "../sub_projects/Project_45/Project_fortyfive";

import Project_46 from "../sub_projects/Project_46/Project_fortysix";
import Project_47 from "../sub_projects/Project_47/Project_fortyseven";

// Mapping list of all projects
const projectMap = {
  1: Project_1,
  2: Project_2,
  3: Project_3,
  4: Project_4,
  5: Project_5,
  6: Project_6,
  7: Project_7,
  8: Project_8,
  9: Project_9,
  10: Project_10,
  11: Project_11,
  12: Project_12,
  13: Project_13,
  14: Project_14,
  15: Project_15,
  16: Project_16,
  17: Project_17,
  18: Project_18,
  19: Project_19,
  20: Project_20,
  21: Project_21,
  22: Project_22,
  23: Project_23,
  24: Project_24,
  25: Project_25,
  26: Project_26,
  27: Project_27,
  28: Project_28,
  29: Project_29,
  30: Project_30,
  31: Project_31,
  32: Project_32,
  33: Project_33,
  34: Project_34,
  35: Project_35,
  36: Project_36,
  37: Project_37,
  38: Project_38,
  39: Project_39,
  40: Project_40,
  41: Project_41,
  42: Project_42,
  43: Project_43,
  44: Project_44,
  45: Project_45,
  46: Project_46,
  47: Project_47,
};

const ProjectDynamic = () => {

  const { id } = useParams();
  const ProjectComponent = projectMap[id];

  if (!ProjectComponent) {
    return (
      <h1 style={{ textAlign: "center", padding: "40px" }}>
        Project not found
      </h1>
    );
  }

  return (
    <>
          <ProjectComponent />
    </>
  );
};

export default ProjectDynamic;
